import React from 'react';
import {subItemStyle, disableSubItemStyle} from './styles';

export default function CategorySubItem({
  item,
  isDisabled,
  toggleItemStatus,
  preview,
}) {
  const itemStyleClass = isDisabled ? disableSubItemStyle : subItemStyle;
  const itemActionIconClass = item.disabled
    ? 'fa-plus'
    : item.isRequired
    ? ''
    : 'fa-bars';
  const disableIconClass = item.disabled ? '' : 'fa-times';

  return (
    <div data-id={item.value} style={itemStyleClass} key={item.value}>
      <div className="d-flex justify-content-between align-items-center">
        {!preview && (
          <i
            className={`fa ${itemActionIconClass} ${
              item.isRequired ? 'fixed' : 'draggable'
            } cursor-pointer kt-margin-r-10`}
            onClick={() =>
              item.disabled
                ? toggleItemStatus(item.value, 'enable', true, false)
                : {}
            }
          />
        )}
        <div className="text-center" style={{width: '100%'}}>
          {item.label}
        </div>
        {!preview && (
          <i
            className={`fa ${disableIconClass} cursor-pointer`}
            onClick={() => toggleItemStatus(item.value, 'disable', true, false)}
          />
        )}
      </div>
    </div>
  );
}
